module.exports = __webpack_public_path__ + "static/img/maintenance.39636ce.svg";